import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
//import { SourceService } from '../../services/source.service';
import { User } from '../../models/User';
import { Source } from '../../models/Source';
import { UserService } from '../../services/userService';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-source',
  standalone: true,
  imports: [],
  templateUrl: './source.component.html',
  styleUrl: './source.component.css'
})

export class SourceComponent implements OnInit {

  constructor(private router: Router, private userService: UserService, private authService: AuthService) {
  }

  User: User = new User();

  ngOnInit() {
    this.User = new User();
    this.userService.getCurrentUser().subscribe(data => {
      this.User = data;
      if (this.User.Sources.length == 1) {
        this.authService.setLoginSource(this.User.Sources[0]);
        //sessionStorage.setItem('source', JSON.stringify(this.User.Sources[0]));
        console.log("user in source component :", this.User);
        switch (this.User.CanRequest) {
          case false:
            this.router.navigate(['manage/result-list']);
            break;
          default:
            this.router.navigate(['manage/request-list']);
            break;
        }
      }
    });
  }

  selectSource(source: Source) {
    this.authService.setLoginSource(source);
    switch (this.User.CanRequest) {
      case false:
        this.router.navigate(['manage/result-list']);
        break;
      default:
        this.router.navigate(['manage/request-list']);
        break;
    }
  }
}
